import { Route, MemoryRouter, Routes } from "react-router-dom";
import { GlobalConfiguration } from "../ts/infrastructure";

const config = new GlobalConfiguration();

const Version = () => (
    <div>
        <h2>Outlook PEP Add-in</h2>
        <p>Version: {config.getVersion()}</p>
    </div>
);

const NonOfficeApp = () => {
    return (
        <MemoryRouter>
            <Routes>
                <Route path="/" element={<Version/>} />
            </Routes>
        </MemoryRouter >
    );
}

export default NonOfficeApp;